import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerPlanItemEditReasonDialogComponent } from './customer-plan-item-edit-reason-dialog.component';
import { FormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';



@NgModule({
  declarations: [
    CustomerPlanItemEditReasonDialogComponent
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule,
    DialogContainerModule,
  ]
})
export class CustomerPlanItemEditReasonDialogModule { }
